var mask2 = "/static/2a21afdbd009c1df.png";

export { mask2 as default };
//# sourceMappingURL=mask-2.png.js.map
